module.exports = __webpack_public_path__ + "static/onb_logo-95b4b959e8875cea997aa9ea9adf50b9.svg";